import { v4 as uuidv4 } from 'uuid';
export default (valueType = "DoubleUploadImg") => {
  const uuid = uuidv4()
  const uuid2 = uuidv4()
  return {
    $id: uuid,
    valueType: valueType,
    FormItemProps: {
      label: '双图上传',
      name: [uuid, uuid2],
      required: false,
      style: {}
    },
  }
};